import React from 'react';
import { FormControlLabel, Grid, Stack, Switch, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const GradingScaleFormDialog = ({ open, onClose, onSubmit, editingScale, formData, setFormData, saving, isMobile = false }) => (
  <FormDialog open={open} onClose={onClose} onSubmit={onSubmit} title={editingScale ? 'Edit Grading Scale' : 'Add Grading Scale'} saving={saving} isMobile={isMobile}>
    <Stack spacing={2} sx={{ pt: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Scale Code" value={formData.scale_code} onChange={(e) => setFormData({ ...formData, scale_code: e.target.value })} placeholder="e.g., UCE, UACE, PLE" required />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Scale Name" value={formData.scale_name} onChange={(e) => setFormData({ ...formData, scale_name: e.target.value })} placeholder="e.g., O-Level Grading" required />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={2} label="Description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
        </Grid>
      </Grid>
      <Stack direction="row" spacing={2}>
        <FormControlLabel control={<Switch checked={formData.is_default} onChange={(e) => setFormData({ ...formData, is_default: e.target.checked })} />} label="Default" />
        <FormControlLabel control={<Switch checked={formData.is_active} onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })} />} label="Active" />
      </Stack>
    </Stack>
  </FormDialog>
);

export default GradingScaleFormDialog;
